import { apiFetch } from "../useApi";

export default async function deleteAddresses() {
  const response = await apiFetch(`/addresses/delete`, {
    method: 'DELETE',
    body: JSON.stringify({addressIds: 'all'}),
  });
  return response.json();
}
